import { Box, Typography, InputAdornment, TextField } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { TextButton } from "components/TextButton";
import { useStyles } from "../../styles";
import { RelatedOrder } from "../../types";
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { OrderList } from "./components/orderList";

type Props = {
  relatedOrders: RelatedOrder[],
  onSearch: (value: string) => void,
  propertySearchQuery: string,
  hasOrders: boolean,
  hideSearchOnMobile: boolean,
  showMobileClear: boolean,
  onClear: () => void,
}

export const RelatedOrders: FC<Props> = ({
  relatedOrders,
  onSearch,
  propertySearchQuery,
  hasOrders,
  hideSearchOnMobile,
  showMobileClear,
  onClear,
}) => {
  const classes = useStyles({});
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <>
      <Box className={classes.relatedOrdersTitleContainer}>
        <Typography className={classes.relatedOrdersTitle}>{t('common:relatedOrdersTitle')}</Typography>
        <Box className={classes.relatedOrdersActions}>
          <Typography className={classes.relatedOrdersTotalsBadge}>
            {relatedOrders.length}
            {' '}
            {t('common:totalLabel')}
          </Typography>
          {showMobileClear && (
            <Box className={classes.mobileClearButton}>
              <TextButton text={t('common:clear')} textColor={theme.palette.secondary.main} onClick={onClear} />
            </Box>
          )}
        </Box>
      </Box>

      {hasOrders && (
        <Box className={hideSearchOnMobile ? classes.hideFiltersOnMobile : undefined}>
          <TextField
            hiddenLabel
            placeholder={t('common:filterByAddressPlaceholder')}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <FontAwesomeIcon icon={faSearch} className={classes.searchIcon} />
                </InputAdornment>
              ),
            }}
            variant="filled"
            className={classes.searchBox}
            fullWidth
            value={propertySearchQuery}
            onChange={(e) => onSearch(e.target.value)}
          />
        </Box>
      )}

      {!hasOrders && (<Typography className={classes.relatedOrdersTotalsBadge}>{t('orders:no-orders-yet')}</Typography>)}

      <OrderList relatedOrders={relatedOrders} />
    </>
  );
};